<template>
  <div>
    <page-header
      name="Clientes"
    >
      <b-button
        variant="primary"
        @click="newType"
      >
        <FeatherIcon icon="PlusIcon" />
        &nbsp;<span class="text-nowrap">Adicionar</span>
      </b-button>
    </page-header>
    <Grid
      :fields="fields"
      :items="items"
      edit-button-label="edit"
      new-button-label="new"
      :show-search="false"
      @onChangePage="getClients"
    >
      <template v-slot:search>
        <b-row class="p-0 pl-1">
          <b-col
            md="10"
            class="p-0 pr-1"
          >
            <b-form-input
              v-model="search.search"
              class="filter-input"
              placeholder="Pesquisar por Nome"
              name="nome"
            />
          </b-col>
          <b-col
            sm="12"
            md="2"
          >
            <b-button
              variant="secondary"
              type="button"
              @click="getClients"
            >
              <FeatherIcon icon="SearchIcon" />
              <span
                class="text-nowrap"
              />
            </b-button>
          </b-col>
        </b-row>
      </template>
      <template
        #cell(logo)="data"
      >
        <company-logo
          :company="data.item"
          size="lg"
        />
      </template>
      <template
        #cell(action)="data"
      >
        <b-button-group justified>
          <i2-icon-button
            icon="KeyIcon"
            variant="outline-warning"
            @click="showTokens(data.item)"
          />
          <i2-icon-button
            icon="LogInIcon"
            :variant="currentClient === data.item.uuid ? 'outline-success' : 'outline-secondary' "
            @click="setCurrentClient(data.item)"
          />
          <i2-icon-button
            icon="EditIcon"
            variant="outline-primary"
            @click="setCurrentType(data.item)"
          />
          <i2-icon-button
            fa-icon="fa-trash"
            variant="outline-danger"
            @click="onDelete(data.item)"
          />
        </b-button-group>
      </template>
    </Grid>
    <i2-side-bar
      :is-active.sync="isActivated"
      window-title="Clientes"
    >
      <type-form
        :is-active.sync="isActivated"
        :model-uuid="currentType"
        @onModelSave="onClientSave()"
        @onCancel="onCancelEdit()"
      />
    </i2-side-bar>
    <ClientTokenModal
      :is-active-token.sync="isShowTokens"
      :client-uuid="currentClient"
      :title="currentTokenModalTitle"
      @onClose="onCloseTokens"
    > </ClientTokenModal>
  </div>
</template>

<script>

import PageHeader from '@/components/i2/layout/PageHeader.vue'
import TypeForm from '@/views/clients/ClientForm.vue'
import ClientTokenModal from '@/views/clients/ClientTokenModal.vue'
import { mapActions } from 'vuex'
import CompanyLogo from '@/views/clients/CompanyLogo'

export default {
  name: 'ClientList',
  components: {
    CompanyLogo,
    PageHeader,
    TypeForm,
    ClientTokenModal,
  },
  data() {
    return {
      search: {
        search: '',
        type: '',
      },
      user: {
        client: {
          uuid: null,
        },
      },
      fields: [
        {
          key: 'logo',
          label: 'logo',
          class: 'w-10',
        },
        {
          key: 'uuid',
          label: 'id',
          class: 'w-30',
        },
        {
          key: 'name',
          label: 'Nome',
          class: 'w-30',
        },
        {
          key: 'action',
          label: 'Ações',
          class: 'w-30',
        },
      ],
      items: [],
      currentClient: '',
      isShowTokens: false,
      currentType: '',
      typesIndexes: [],
      isActivated: false,
      currentTokenModalTitle: '',
    }
  },
  async mounted() {
    this.user = this.$user.getCurrentUser()
    if (this.user) {
      this.currentClient = this.user.client.uuid
    }
    await this.getClients(1)
  },
  methods: {
    ...mapActions('auth', ['me']),
    setCurrentType(data) {
      this.currentType = data.uuid
      this.isActivated = true
    },
    newType() {
      this.currentType = ''
      this.isActivated = true
    },
    async getClients(page) {
      this.items = await this.$search.get(
        'clients',
        page,
        this.search,
        '',
      )
    },
    onClientSave() {
      this.currentType = ''
      this.isActivated = false
      this.getClients()
    },
    onCancelEdit() {
      this.isActivated = false
      this.currentType = ''
    },
    onDelete(client) {
      this.$bvModal
        .msgBoxConfirm('Por favor, confirme a exclusão do cliente.', {
          title: 'Confirma a exclusão?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(async value => {
          if (value) {
            const response = await this.$http.delete(`clients/${client.uuid}`)
            if (response.error) {
              this.$notify.error(response.error_message)
              return
            }
            this.$notify.success('Cliente removido com sucesso.')
            await this.getClients()
          }
        })
    },
    async setCurrentClient(client) {
      const response = await this.$http.post(`clients/${client.uuid}/select`)
      if (response.error) {
        this.$notify.error(response.error_message)
      }
      this.currentClient = response.client.uuid
      this.$notify.success('Cliente alterado com sucesso')
      await this.me()
      await this.getClients()
    },
    showTokens(item) {
      this.isShowTokens = true
      this.currentClient = item.uuid
      this.currentTokenModalTitle = 'Adicionar Tokens'
      this.$bvModal.show('token-modal')
    },
    onCloseTokens() {
      this.isShowTokens = false
      this.getClients()
    },
  },
}
</script>

<style scoped>

</style>
